import type { SearchResult } from './search-types';

type NavigateFn = (opts: {
  to: '/cases/$caseId' | string;
  params?: { caseId: string };
  search?: { event?: string };
}) => unknown;

/** Naviger fra søketreff – hendelser åpnes via ?event= for scroll/expand i saksrom. */
export function navigateToSearchResult(navigate: NavigateFn, result: SearchResult): void {
  if (result.caseId && result.eventId) {
    void navigate({
      to: '/cases/$caseId',
      params: { caseId: result.caseId },
      search: { event: result.eventId },
    });
    return;
  }
  if (result.caseId) {
    void navigate({
      to: '/cases/$caseId',
      params: { caseId: result.caseId },
      search: {},
    });
    return;
  }
  void navigate({ to: result.href });
}
